import { createSlice } from '@reduxjs/toolkit';

// DOMAIN
import { Domain } from 'constant';

// MODEL
import { OnBoardingState } from 'model';

// REDUCER ACTION
import {
  changeLoading,
  setLovedOne,
  setNric,
  setAccountStatus,
  setSuggestedRole,
  setVerified,
  setSessionId,
  setB3LookupResult,
  setLookupBlocked,
  setCompletedOnboard,
  setB3Snapshot,
  setLinkpassPrefill
} from './reducers';

export const initialState: OnBoardingState = {
  loading: false,
  lovedOne: '',
  nric: '',
  accountStatus: undefined,
  suggestedRole: undefined,
  isVerified: false,
  sessionId: undefined,
  b3LookupResult: undefined,
  lookupBlocked: undefined,
  completedOnboard: false,
  b3Snapshot: undefined,
  linkpassPrefill: undefined
};

export const onBoardingSlice = createSlice({
  name: Domain.OnBoarding,
  initialState,
  reducers: {
    changeLoading,
    setLovedOne,
    setNric,
    setAccountStatus,
    setSuggestedRole,
    setVerified,
    setSessionId,
    setB3LookupResult,
    setLookupBlocked,
    setCompletedOnboard,
    setB3Snapshot,
    setLinkpassPrefill,
    reset: () => initialState
  }
});

export default onBoardingSlice.reducer;
